import { type Transition, type Variants } from 'framer-motion';

import { EASE_CUBIC } from '@pkg/components/Sections/Profile/StyledThemeProvider/themes/default';

const translateDistance = 20;

export enum MainVariant {
    Hidden = 'hidden',
    Show = 'show',
}

export const mainVariants: Variants = {
    [MainVariant.Hidden]: {
        opacity: 0,
        translateY: `${translateDistance}px`,
    },
    [MainVariant.Show]: {
        opacity: 1,
        translateY: 0,
    },
};

export const mainTransition: Transition = {
    ease: EASE_CUBIC,
    duration: 0.4,
};
